export class DocumentDbClusterParameterGroups {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "parameterGroups",
            "baseName": "parameterGroups",
            "type": "Array<DocumentDbClusterParameterGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DocumentDbClusterParameterGroups.attributeTypeMap;
    }
    constructor() {
    }
}
